const lang = document.querySelector('.js-lang');
const langToggle = document.querySelector('.js-lang__active');

if (lang && langToggle) {
	langToggle.addEventListener('click', () => {
		lang.classList.toggle('active');
	});

	const { body } = document;

	body.addEventListener('click', (e) => {
		if (e.target.closest('.js-lang') === null) {
			lang.classList.remove('active');
		}
	});
}
